import React from 'react';

const getPath = (name, props) => {
  switch (name) {
    case 'email':
      return (
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 477.867 477.867" width={props.width} height={props.height}>
<g>
	<g>
		<path fill={props.fill} d="M460.8,68.267H17.067C7.641,68.267,0,75.908,0,85.333v307.2c0,9.426,7.641,17.067,17.067,17.067H460.8
			c9.426,0,17.067-7.641,17.067-17.067v-307.2C477.867,75.908,470.226,68.267,460.8,68.267z M432.811,102.4L238.933,251.529
			L45.056,102.4H432.811z M443.733,375.467h-409.6V137.062L228.54,286.6c6.13,4.707,14.657,4.707,20.787,0l194.406-149.538V375.467z
			"/>
	</g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
</svg>
      );

    case 'lock':
        return(
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width={props.width} height={props.height}
	 viewBox="0 0 426.667 426.667">
<g>
	<g>
		<path fill={props.fill} d="M330.704,170.667H95.963C78.405,170.667,64,184.951,64,202.572v192.19c0,17.593,14.31,31.905,31.963,31.905h234.742
			c17.557,0,31.963-14.284,31.963-31.905v-192.19C362.667,184.979,348.357,170.667,330.704,170.667z M320,384H106.667V213.333H320
			V384z"/>
	</g>
</g>
<g>
	<g>
		<path  fill={props.fill} d="M217.082,0h-7.498c-56.815,0-102.918,46.172-102.918,102.978v81.645h42.667v-81.645c0-33.256,27.014-60.311,60.251-60.311
			h7.498c33.22,0,60.251,27.032,60.251,60.311v81.645H320v-81.645C320,46.134,273.866,0,217.082,0z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
        )
      case 'bell':
          return(
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} x="0px" y="0px"
                   viewBox="0 0 512 512">
<g>
	<g>
		<path fill={props.fill} d="M444.32,356.52L421,340.973V206c0-85.925-66.023-156.707-150-164.311V15c0-8.284-6.716-15-15-15s-15,6.716-15,15v26.689
			C157.023,49.293,91,120.075,91,206v134.973L67.68,356.52C63.506,359.302,61,363.984,61,369v60c0,8.284,6.716,15,15,15h98.875
			c7.041,38.627,40.726,68,81.125,68c40.398,0,74.084-29.373,81.125-68H436c8.284,0,15-6.716,15-15v-60
			C451,363.984,448.493,359.301,444.32,356.52z M256,482c-23.789,0-43.935-16.059-50.359-38H306.36
			C299.935,465.941,279.789,482,256,482z M421,414c-13.921,0-313.614,0-330,0v-36.973l23.32-15.547
			c4.173-2.781,6.68-7.465,6.68-12.48V206c0-74.439,60.561-135,135-135s135,60.561,135,135v143c0,5.016,2.507,9.699,6.68,12.48
			L421,377.027V414z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
        )
      case 'eye':
          return(
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
              width={props.width} height={props.height} x="0px" y="0px" viewBox="0 0 512.000000 512.000000"
              preserveAspectRatio="xMidYMid meet">

              <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M3753 3864 c-220 -226 -282 -284 -298 -280 -11 3 -85 27 -165 55
-273 94 -497 127 -804 118 -212 -6 -318 -21 -514 -73 -517 -135 -972 -446
-1289 -882 -67 -92 -153 -232 -153 -249 0 -24 185 -286 275 -392 165 -190 383
-371 598 -492 51 -29 94 -54 97 -56 3 -3 -117 -123 -265 -268 l-270 -263 50
-51 c27 -28 54 -51 60 -51 13 0 3065 3052 3065 3065 0 11 -91 105 -102 105 -3
0 -132 -129 -285 -286z m-1747 -354 c-269 -157 -456 -418 -527 -735 -18 -80
-18 -350 0 -430 36 -162 104 -312 197 -437 l54 -73 -55 -55 -55 -55 -77 39
c-174 90 -333 206 -492 361 -125 122 -203 214 -292 347 l-60 88 60 88 c286
417 693 716 1181 868 137 43 149 42 66 -6z m1214 -7 c58 -18 109 -38 115 -44
6 -6 -1 -20 -21 -40 l-31 -30 -30 25 c-17 15 -71 51 -120 82 -101 64 -90 65
87 7z m-442 -23 c46 -11 115 -33 153 -50 73 -31 239 -133 239 -147 0 -5 -51
-59 -114 -122 l-114 -114 -58 36 c-111 68 -161 81 -324 81 -128 0 -152 -2
-202 -22 -32 -13 -58 -25 -58 -27 0 -1 11 -23 25 -46 28 -50 34 -129 12 -182
-19 -45 -89 -105 -132 -113 -57 -10 -133 1 -165 25 -16 11 -31 21 -34 21 -2 0
-15 -26 -28 -57 -20 -51 -22 -75 -22 -203 0 -163 13 -213 81 -324 l36 -58
-117 -117 -117 -116 -25 30 c-74 89 -150 251 -181 387 -21 96 -21 298 1 395
39 175 122 330 250 461 155 160 352 256 586 286 67 8 225 -4 308 -24z"/>
                <path d="M3702 3367 l-53 -53 76 -48 c250 -159 530 -439 660 -661 l27 -46 -47
-72 c-81 -122 -135 -187 -255 -311 -190 -195 -364 -322 -605 -441 -120 -59
-352 -144 -435 -160 -33 -6 -32 -5 18 24 219 123 405 337 493 565 93 239 96
530 9 768 -32 87 -96 208 -110 208 -5 0 -29 -23 -54 -52 l-45 -51 25 -49 c42
-84 82 -219 94 -322 13 -112 7 -203 -21 -324 -106 -460 -556 -777 -1025 -722
-103 12 -238 52 -322 94 l-49 25 -128 -129 -129 -129 30 -11 c57 -22 249 -70
353 -87 83 -14 161 -18 356 -18 277 1 344 9 583 71 574 149 1083 528 1392
1037 62 102 64 88 -35 237 -167 249 -375 461 -634 644 -51 36 -99 66 -105 66
-6 0 -35 -24 -64 -53z"/>
                <path d="M2726 2391 l-398 -398 29 -11 c93 -36 251 -43 357 -16 205 53 387
235 440 440 28 108 17 301 -21 367 -7 13 -85 -60 -407 -382z"/>
              </g>
            </svg>
        )
      case 'eye-closed':
          return(
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
              width={props.width} height={props.height} x="0px" y="0px" viewBox="0 0 512.000000 512.000000"
              preserveAspectRatio="xMidYMid meet">

              <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M2350 3780 c-368 -39 -694 -147 -1009 -335 -297 -178 -607 -490 -788
-793 l-55 -92 55 -93 c137 -229 384 -503 597 -661 325 -241 687 -392 1085
-452 164 -25 483 -25 650 0 397 59 766 213 1090 456 55 41 163 137 241 215
147 147 251 278 348 439 l59 96 -56 92 c-137 230 -384 504 -597 662 -324 241
-689 393 -1080 451 -127 19 -424 27 -540 15z m-500 -347 c-348 -296 -491 -733
-379 -1161 56 -214 190 -426 353 -561 36 -30 64 -57 61 -59 -7 -8 -191 68
-298 122 -212 108 -387 237 -563 417 -113 117 -270 316 -281 357 -7 31 73 150
201 298 220 255 494 449 821 581 71 29 132 52 135 52 3 0 -20 -21 -50 -46z
m945 18 c309 -82 571 -343 657 -656 31 -116 31 -354 0 -470 -69 -251 -253
-474 -487 -590 -144 -72 -222 -89 -405 -89 -183 0 -261 17 -405 89 -235 116
-420 342 -486 590 -31 120 -36 294 -11 415 74 361 353 643 712 721 114 25 310
20 425 -10z m656 -65 c332 -148 642 -407 873 -730 31 -43 56 -86 56 -96 0 -30
-159 -239 -269 -353 -189 -195 -382 -338 -605 -446 -118 -58 -265 -115 -273
-108 -2 2 11 15 29 29 128 98 272 287 335 440 193 469 66 976 -327 1311 l-55
47 70 -26 c39 -14 113 -44 166 -68z"/>
                <path d="M2405 3155 c-209 -58 -384 -234 -440 -445 -20 -73 -19 -226 1 -304
53 -205 235 -387 440 -440 35 -9 102 -16 154 -16 52 0 119 7 154 16 205 53
387 235 440 440 21 80 21 228 0 308 -53 205 -235 387 -440 440 -75 19 -239 20
-309 1z m155 -284 c0 -51 -8 -61 -53 -61 -41 0 -127 -59 -158 -108 -16 -26
-32 -57 -34 -69 -16 -78 -11 -73 -66 -73 l-51 0 7 48 c20 139 128 262 264 298
85 23 91 21 91 -35z"/>
              </g>
            </svg>
          )
      case 'shutdown':
          return(
              <svg viewBox="-44 0 512 512" width={props.width} height={props.height}  xmlns="http://www.w3.org/2000/svg">
                  <path fill={props.fill} d="m211.863281 512c-116.820312 0-211.863281-95.035156-211.863281-211.863281 0-95.152344 64.007812-179.171875 155.664062-204.328125 9.386719-2.53125 19.109376 2.949218 21.699219 12.363281 2.574219 9.398437-2.949219 19.121094-12.355469 21.691406-76.359374 20.964844-129.699218 90.980469-129.699218 170.273438 0 97.34375 79.199218 176.554687 176.554687 176.554687 97.351563 0 176.550781-79.210937 176.550781-176.554687 0-77.429688-51.757812-146.996094-125.863281-169.171875-9.34375-2.792969-14.644531-12.636719-11.851562-21.980469 2.800781-9.328125 12.664062-14.621094 21.972656-11.84375 88.9375 26.617187 151.050781 110.082031 151.050781 202.996094 0 116.828125-95.039062 211.863281-211.859375 211.863281zm0 0"/><path d="m211.863281 229.515625c-9.75 0-17.65625-7.894531-17.65625-17.652344v-194.207031c0-9.761719 7.90625-17.65625 17.65625-17.65625s17.652344 7.894531 17.652344 17.65625v194.207031c0 9.757813-7.902344 17.652344-17.652344 17.652344zm0 0"/>
              </svg>
          )
      case 'house':
        return (
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width={props.width} height={props.height} viewBox="0 0 74.000000 70.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,70.000000) scale(0.100000,-0.100000)"
              fill={props.fill} stroke="none">
              <path d="M250 464 c-72 -59 -105 -93 -105 -107 0 -11 5 -22 10 -24 6 -2 54 33
107 77 53 44 101 80 108 80 7 0 55 -36 108 -80 53 -44 100 -80 104 -80 4 0 12
9 17 19 9 15 6 22 -14 35 -31 20 -57 70 -55 104 4 58 1 63 -27 60 -23 -2 -29
-8 -31 -36 l-3 -32 -41 35 c-23 19 -49 35 -57 35 -9 0 -63 -39 -121 -86z"/>
              <path d="M291 396 c-35 -29 -68 -60 -73 -69 -5 -10 -8 -45 -6 -79 l3 -63 55 0
55 0 5 50 c5 50 5 50 40 50 35 0 35 0 40 -50 l5 -50 55 0 55 0 3 71 3 71 -75
61 c-41 34 -80 62 -88 61 -7 0 -42 -24 -77 -53z"/>
            </g>
          </svg>
        )
    default:
      return <path />;
  }
};

const SVGIcon = ({ className = '', fill = '#171926', name, width, height }) => {
  return <React.Fragment>{getPath(name, { fill, width, height })}</React.Fragment>;
};

export default SVGIcon;
